module.exports = __webpack_public_path__ + "static/media/plus.fd305558.svg";